<template>
    <div :bordered="false">
        <div class="table-page-search-wrapper">
            <!-- 顶部查询表单 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                    <a-col :md="6" :sm="6">
                        <a-form-item :label="$t(I18N_KEY.PAYROLL + 'keyword')">
                            <a-input :placeholder="$t(I18N_KEY.PAYROLL + 'keyword')" v-model="queryParam.keyword" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="6">
                        <a-form-item :label="$t(I18N_KEY.PAYROLL + 'status')">
                            <a-select v-model="queryParam.status" allowClear
                                :placeholder="$t(I18N_KEY.PAYROLL + 'statusPlaceholder')" style="width: 100%;"
                                dropdownClassName="status-dropdown-fix"
                                :getPopupContainer="trigger => trigger.parentNode">
                                <a-select-option :value="null">
                                    全部
                                </a-select-option>
                                <a-select-option value="-1">
                                    已取消
                                </a-select-option>
                                <a-select-option value="0">
                                    未提交
                                </a-select-option>
                                <a-select-option value="1">
                                    待审核
                                </a-select-option>
                                <a-select-option value="2">
                                    审核通过
                                </a-select-option>
                                <a-select-option value="3">
                                    审核驳回
                                </a-select-option>
                                <a-select-option value="4">
                                    放款中
                                </a-select-option>
                                <a-select-option value="5">
                                    放款完成
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="10" :sm="10">
                        <a-form-item :label="$t(I18N_KEY.PAYROLL + 'uploadDate')">
                            <a-range-picker v-model="queryParam.date" format="YYYY-MM-DD" style="width: 100%;" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="3" :sm="4">
                        <a-button type="primary" @click="searchQuery">{{ $t('search') }}</a-button>
                    </a-col>
                    <a-col :md="4" :sm="4">
                        <a-button @click="searchReset" icon="reload">{{ $t('reset') }}</a-button>
                    </a-col>
                </a-row>
            </a-form>

            <!-- 新建发薪批次按钮 -->
            <div style="margin: 16px 0;">
                <a-upload name="file" :multiple="false" :action="'/api/web/webpublic/payroll/uploadBatchInfo'"
                    :headers="getHeaders()" :data="uploadDataParam" @change="handleChangeUpload" v-if="this.isHrRole">
                    <a-button type="primary">
                        <a-icon type="upload" />
                        {{ $t(I18N_KEY.PAYROLL + 'createPayrollBatch') }}
                    </a-button>
                </a-upload>
            </div>

            <!-- 数据表格 -->
            <a-table ref="table" size="middle" :columns="columns" :dataSource="dataSource" :pagination="false"
                :loading="loading" bordered @change="handleTableChange" rowKey="id">
                <!-- 状态列自定义渲染 - 修复undefined问题 -->
                <template v-slot:status="scope">
                    <span :style="{ color: getStatusBadgeColor(scope) }">
                        <a-badge :status="getStatusBadgeType(scope)" :text="getStatusText(scope)" />
                    </span>
                </template>

                <!-- 操作列自定义渲染 - 修复record解构错误 -->
                <template v-slot:action="text, record">
                    <a-button style="margin-left: 10px" type="primary" :disabled="isButtonDisabled"
                        @click="handleDetail(record)">
                        {{ $t('view') }}
                    </a-button>
                </template>
            </a-table>
            <div style='margin-top: 15px; text-align: right;'>
                <v-pagination v-if='total' :page-num='form.pageNum' :page-size='form.pageSize' :total='total'
                    @change='handleTableChange' />
            </div>
        </div>
        <v-modal v-model='visible' :title="$t(I18N_KEY.PAYROLL + 'payrollDetail')" @cancel="handleModalClose">
            <div style='padding: 20px;'>
                <payroll-detail v-if='visible' :id='id' :batchNo='batchNo' :fileName='fileName' :createTime='createTime'
                    :totalCount='totalCount' :totalAmount='totalAmount' :effectiveCount='effectiveCount'
                    :effectiveAmount='effectiveAmount' :rejectCount='rejectCount' :rejectReason='rejectReason'
                    :status="status" @close="handleModalClose" />
            </div>
        </v-modal>
    </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getHeaders } from '@/utils/request'
import { queryAllPayrollInfo } from '@/webpublicapi/payroll'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import vModal from '../modules/Modal'
import PayrollDetail from './payrollDetail'
import moment from 'moment'

const I18N_KEY = {
    PAYROLL: 'payroll.',
}

export default {
    name: 'PayrollBatchList',
    components: {
        Dict,
        DictSelect,
        vModal,
        PayrollDetail
    },
    data() {
        return {
            I18N_KEY,
            isButtonDisabled: false,
            visible: false,
            selectedRowKeys: [],
            loading: false,
            total: 0,
            isFinanceRole: false,
            isHrRole: false,
            id: null,
            batchNo: null,
            fileName: null,
            createTime: null,
            totalCount: null,
            totalAmount: null,
            effectiveCount: null,
            effectiveAmount: null,
            rejectCount: null,
            rejectReason: null,
            status: null,
            dataSource: [],
            form: {
                pageNum: 1,
                pageSize: 10,
            },
            queryParam: {
                keyword: null,
                date: [],
                type: null,
                status: null // 补充status查询参数
            },
            uploadDataParam: {},
        }
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'batchNo'),
                    align: 'center',
                    dataIndex: 'batchNo',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'fileName'),
                    align: 'center',
                    dataIndex: 'fileName',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'creatorName'),
                    align: 'center',
                    dataIndex: 'creatorName',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'createTime'),
                    align: 'center',
                    dataIndex: 'createTime',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'totalCount'),
                    align: 'center',
                    dataIndex: 'totalCount',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'totalAmount'),
                    align: 'center',
                    dataIndex: 'totalAmount',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'rejectCount'),
                    align: 'center',
                    dataIndex: 'rejectCount',
                    customRender: (text, record) => {
                        if (record.status !== 3) return '-'; // 非驳回状态不显示
                        return (
                            <span style="color:red;cursor:pointer;" title="需处理">
                                {text || 0}
                            </span>
                        );
                    }
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'rejectReason'),
                    align: 'center',
                    dataIndex: 'rejectReason',
                    customRender: (text, record) => {
                        return record.status === 3 ? (text || '-') : '';
                    }
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'paymentCount'),
                    align: 'center',
                    dataIndex: 'payrollCount',
                    customRender: (text, record) => {
                        if (record.status !== 5) return '-';
                        return <span style="color: #52c41a;">{text || 0}</span>;
                    }
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'paymentAmount'),
                    align: 'center',
                    dataIndex: 'payrollAmount',
                    customRender: (text, record) => {
                        if (record.status !== 5) return '';
                        return (
                            <span style="color: #52c41a; font-weight: bold;">
                                ¥{text || 0}
                            </span>
                        );
                    }
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'status'),
                    align: 'center',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' }
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'updateTime'),
                    align: 'center',
                    dataIndex: 'updateTime',
                },
                {
                    title: this.$t(I18N_KEY.PAYROLL + 'action'),
                    align: 'center',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' }
                },
            ]
        },
    },
    created() {
        this.loadData();
        this.isRoleCode();
    },
    methods: {
        getHeaders() {
            return getHeaders()
        },

        isRoleCode() {
            return new Promise((resolve) => {
                try {
                    const roleCodeStr = localStorage.getItem('roleCodes');
                    const roleCodeArray = JSON.parse(roleCodeStr || '[]');
                    this.isFinanceRole = Array.isArray(roleCodeArray) && roleCodeArray.includes('finance_user');
                    this.isHrRole = Array.isArray(roleCodeArray) && roleCodeArray.includes('hr_user');
                } catch (e) {
                    this.isFinanceRole = false;
                    this.isHrRole = false;
                }
                resolve();
            });
        },

        handleModalClose() {
            this.visible = false;
            this.loadData();
        },

        // 修复：处理status为undefined的情况，兜底显示"未知状态"
        getStatusText(text) {
            // 空值/undefined兜底
            console.log('插槽完整数据：', text);

            if (text === undefined || text === null || text === '') {
                return '未知状态';
            }
            const statusStr = String(text);
            const STATUS_MAP = {
                '-1': '已取消',
                '0': '未提交',
                '1': '待审核',
                '2': '审核通过',
                '3': '审核驳回',
                '4': '放款中',
                '5': '放款完成'
            };
            return STATUS_MAP[statusStr] || '未知状态'; // 兜底显示"未知状态"而非原数值
        },

        getStatusBadgeColor(scope) {
            const statusStr = String(scope);
            switch (statusStr) {
                case '-1': return '#333333';   // 已取消 → 黑色
                case '0': return '#F5F5F5';     // 未提交 → 橙色
                case '1': return '#FFFF00';     // 待审核 → 亮黄
                case '2': return '#4096FF';     // 审核通过 → 绿色
                case '3': return '#f5222d';     // 审核驳回 → 红色
                case '4': return '#FFFF00';     // 放款中 → 亮黄
                case '5': return '#52c41a';     // 放款完成 → 绿色
                default: return '#333333';      // 未知状态 → 黑色
            }
        },

        // 3. Badge 状态点类型（给 a-badge 的 status 属性用）
        getStatusBadgeType(scope) {
            const statusStr = String(scope);
            const typeMap = {
                '-1': 'default',
                '0': 'warning',
                '1': 'processing',
                '2': 'success',
                '3': 'error',
                '4': 'processing',
                '5': 'success'
            };
            return typeMap[statusStr] || 'default';
        },

        searchQuery() {
            this.form.pageNum = 1
            this.loadData()
        },

        loadData() {
            this.loading = true
            const params = this.getQueryParams()

            queryAllPayrollInfo(params)
                .then((res) => {
                    if (res.code === 1000) {
                        this.total = res.data.total
                        // 修复：给缺失status字段的行补充默认值
                        this.dataSource = res.data.rows !== null ? res.data.rows : []
                        console.log(this.dataSource, "尚书事");

                    } else {
                        this.$message.error(res.msg)
                        this.dataSource = []
                    }
                    this.loading = false
                })
                .catch((e) => {
                    this.loading = false
                    this.$message.error(e.message)
                })
        },

        getQueryParams() {
            const { date, status } = this.queryParam
            const data = {
                ...this.queryParam,
                uploadStartDate: date?.[0] ? this.transformTime(date[0]) : null,
                uploadEndDate: date?.[1] ? this.transformTime(date[1]) : null,
                pageNum: this.form.pageNum,
                pageSize: this.form.pageSize,
                // 补充：传递status查询参数
                ...(status !== null && status !== undefined ? { status } : {})
            }
            return filterObj(data)
        },

        transformTime(time) {
            // 修复：兼容非moment对象的情况
            if (!moment.isMoment(time)) {
                return '';
            }
            return time.format('YYYY-MM-DD')
        },

        handleTableChange(pageNum, pageSize) {
            this.form.pageNum = pageNum
            this.form.pageSize = pageSize
            this.loadData()
        },

        searchReset() {
            this.queryParam = {
                keyword: null,
                date: [],
                type: null,
                status: null // 重置status参数
            }
            this.form.pageNum = 1
            this.loadData()
        },

        handleChangeUpload(info) {
            if (info.file.status === 'done') {
                // 修复：避免response为空报错
                if (info.file.response?.code === 1000) {
                    this.$message.success(`${info.file.name} 上传成功`)
                    this.loadData()
                } else {
                    this.$message.error(info.file.response?.msg || '上传失败')
                }
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 上传失败`)
            }
        },
        changeModal(visible) {
            this.visible = visible;
            if (!visible) {
                this.loadData();
            }
        },
        handleDetail(row) {
            console.log(row, "shenme");

            this.id = row.id;
            this.batchNo = row.batchNo;
            this.fileName = row.fileName;
            this.createTime = row.createTime;
            this.totalCount = row.totalCount;
            this.totalAmount = row.totalAmount;
            this.effectiveCount = row.effectiveCount;
            this.effectiveAmount = row.effectiveAmount;
            this.rejectCount = row.rejectCount;
            this.rejectReason = row.rejectReason;
            this.status = row.status;
            this.changeModal(true);
        }
    },
}
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";

/deep/ .status-dropdown-fix {
    /* 1. 强制设置最大高度，防止内容过多导致计算异常 */
    max-height: 300px !important;

    /* 2. 确保内部可滚动 */
    overflow-y: auto !important;

    /* 3. 关键：阻止滚动事件冒泡给父元素 (解决穿透) */
    overscroll-behavior: contain !important;

    /* 4. 提升层级，防止被遮挡 */
    z-index: 1050 !important;
}

/* 针对 Ant Design Vue 下拉菜单内部列表的额外修复 */
/deep/ .status-dropdown-fix .ant-select-dropdown-menu {
    max-height: 300px !important;
    overflow-y: auto !important;
    overscroll-behavior: contain !important;
}
</style>